import type { MessageKey } from 'types/LocaleMessageKey';

import SectionHeading from '@/app/components/SectionHeading';

interface LandingPageScrollFeatureTitleProps {
  readonly content: MessageKey;
}

const LandingPageScrollFeatureTitle = ({
  content,
}: LandingPageScrollFeatureTitleProps) => {
  return (
    <SectionHeading
      animated
      content={content}
      emAnimationProps={{
        transition: { duration: 1.5, type: 'tween', delay: 0.5 },
      }}
      multiline
      typographyProps={{
        height: 'tight',
        className: 'tracking-tighter lg:max-w-none text-left',
        color: 'inherit',
        variant: 'h2',
      }}
      wrapperAnimationProps={{
        transition: { duration: 1, type: 'tween', delay: 0.5 },
      }}
    />
  );
};

export default LandingPageScrollFeatureTitle;
